import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'si-appo-arrival-confirm-button',
  templateUrl: './appo-arrival-confirm-button.component.html',
  styleUrls: ['./appo-arrival-confirm-button.component.scss']
})
export class AppoArrivalConfirmButtonComponent {
  @Input() appoId: number;
  @Input() centerName: string;
  @Input() centerAddress: string;
  @Input() centerLatitude: number;
  @Input() centerLongitude: number;
  @Input() arrivalStartDate: number;
  @Input() arrivalEndDate: number;
  @Input() cardNumberSEOGA: string;
  @Input() actions: string[];
  displayConfirmArrivalDialog: boolean;

  constructor(
    private router: Router
  ) { }

  isSoon(): boolean {
    return this.arrivalStartDate > Date.now();
  }

  isLate(): boolean {
    return this.arrivalEndDate < Date.now()
  }

  onClickConfirmButton(): void {
    event.stopPropagation();
    event.preventDefault();
    this.displayConfirmArrivalDialog = true;
  }

  onConfirmArrival(): void {
    this.router.navigate(['appointment/waiting-room']);
  }
}
